const KIT_TYPE_ORDER = ['educator', 'student', 'refill']

export function buildKitTypes ({
  includeEducator,
  includeStudent,
  includeRefill
}) {
  const selections = {
    educator: includeEducator,
    student: includeStudent,
    refill: includeRefill
  }

  return KIT_TYPE_ORDER
    .filter(kitType => selections[kitType])
    .join('|')
}
